const percentageOptions = { maximumFractionDigits: 0, style: 'percent' }

export function percentage(pct) {
    if ((pct ?? null) === null) {
        return '-'
    }
    if (pct < 0) {
        return `(${(-pct).toLocaleString([], percentageOptions)})`
    }

    return pct.toLocaleString([], percentageOptions)
}
